// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"90ae40cd","732":"20d935e1","977":"2477cf97"}[chunkId] + ".chunk.js";
};